import type { I18nLocale } from '#/i18n/types/I18nLocale';
import type { RadiusParam } from '#/modules/search/helpers/radius';
import { searchGetQueryParamsFromFiltersByName } from '#/modules/search/routing/helpers/searchGetQueryParamsFromFiltersByName';
import { searchOrgsRouteReference } from '#/modules/search/routing/search.routes';
import type { SearchOrgFiltersByName } from '#/modules/search/types/FiltersByName/SearchOrgFiltersByName';
import type { SearchSortType } from '#/modules/search/types/SearchSortType';

import { searchOrgsRoutePathByLocale } from './searchOrgs.route-paths';

type Args = {
  locale: I18nLocale;
  q?: string;
  radius?: RadiusParam;
  filtersByName?: Omit<SearchOrgFiltersByName, 'type'>;
  sort?: SearchSortType;
  pageIndex?: number;
};

export function searchGetOrgsRoutePath({
  locale,
  filtersByName,
  q,
  radius,
  sort,
  pageIndex,
}: Args) {
  const queryParams = searchGetQueryParamsFromFiltersByName(filtersByName);

  if (q) queryParams.q = q;
  if (radius) queryParams.radius = radius;
  if (sort && sort !== 'relevance') queryParams.sort = sort;
  if (pageIndex) queryParams.page = pageIndex + 1;

  return searchOrgsRouteReference
    .with(queryParams)
    .replace('/-lang/-segment', searchOrgsRoutePathByLocale[locale]);
}
